import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import ColoredValue from '../../../../components/ColoredValue';
import CurruncyFormat from '../../../../components/CurruncyFormat';
import {
  getAlgoListDataCachedSelectedDay,
  getIsMtmShow,
} from '../../../../stores/algos-list/getters';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
  },
  BluredMtm: {
    color: 'var(--color-root-black)',
    fontWeight: 400,

    '&.isTradeActive': {
      color: 'var(--color-colorPrimary-main)',
    },
  },
}));

const BluredMtm = ({ id }) => {
  const classes = useStyles();
  const isTradeActive = useSelector((state) => {
    const { status = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === id) || {};

    return status === 'TRADE_ACTIVE' ? true : false;
  });

  return (
    <div
      className={`${classes.BluredMtm} ${isTradeActive ? 'isTradeActive' : ''}`}
    >
      ₹ XXX
    </div>
  );
};

const CellMtm = ({ row = {} }) => {
  const isShow = useSelector(getIsMtmShow);
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;

  const pnl = useSelector((state) => {
    let { pnl = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    if (pnl === 0) {
      // pnl is 0
    } else if (!pnl || isNaN(pnl)) {
      pnl = '';
    }

    return pnl;
  });

  let color = '';

  if (pnl || pnl === 0) {
    if (pnl < 0) {
      color = 'red';
    } else {
      color = 'green';
    }
  }

  const hideMtm = !isShow && (pnl || pnl === 0) ? true : false;

  return (
    <div className={classes.root}>
      {hideMtm ? (
        <BluredMtm id={_id} />
      ) : (
        <ColoredValue className="algos-cell-mtm" color={color}>
          <CurruncyFormat
            value={pnl}
            thousandsGroupStyle="lakh"
            prefix={pnl || pnl === 0 ? '₹' : ''}
          />
        </ColoredValue>
      )}
    </div>
  );
};

export default CellMtm;
